import keyMirror from 'keymirror';

export const imagePreviewActionTypes = keyMirror({
	SET_IMAGE_PREVIEW: null,
});
